import { DialogSchema } from '@feedyou-ai/feedbot-schema'
import { isNotEmptyElement } from '@feedyou/utils'

import { Option } from '../../../../../lib/options'
import { Dialogs } from '../../../../steps/types'

export function getSelectOptionForDialog(dialog: DialogSchema): Option {
  const dialogId = dialog?.id
  return { label: dialog?.name || dialogId, value: dialogId, dataTest: dialogId }
}

export function getSelectOptions(dialogs: Dialogs) {
  return Object.values(dialogs).map(getSelectOptionForDialog).filter(isNotEmptyElement)
}
